import { ButtonModel } from '../models/button/button.model';
import { FileUploaderModel } from '../models/file-uploader/file-uploader.model';
import { FileUploaderStylingModel } from '../models/file-uploader/file-uploader-styling.model';

export const /** @type {?} */ FileUploaderTemplates = {
  defaultTemplate: {
    property: new FileUploaderModel({
      display: true,
      disable: false,
      main: {
        url: '',
        removeBySuccess: false,
        uniqueFiles: true,
        autoUpload: false
      },
      readFiles: false,
      filesNames: [],
      filesTypes: [],
      filesSizes: [],
      filesDates: [],
      showDropZone: true,
      dropZoneLabel: 'Drop files here or click to select: ',
      showFileActions: true,
      showFilesActions: true,
      uploadFileButton: new ButtonModel({ label: 'Upload' }),
      removeFileButton: new ButtonModel({ label: 'Remove' }),
      uploadFilesButton: new ButtonModel({ label: 'Upload All' }),
      removeFilesButton: new ButtonModel({ label: 'Remove All' }),
    })
  }
}
